export default function getLayers(colors) {
    const scaleFactor = 1 / Math.ceil(window.devicePixelRatio || 1);
    const regularFont = ['Noto Sans Regular'];
    const boldFont = ['Noto Sans Bold'];
    const isCluster = ['has', 'point_count'];
    const isOfType = (type) => ['==', ['get', 'type'], type];

    const jobAddressTitleLayer = {
        id: 'job_address_title',
        type: 'symbol',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('address')],
        layout: {
            'text-field': '{title}',
            'text-font': regularFont,
            'text-size': 10,
            'text-anchor': 'top',
            'text-offset': [0, 0.5],
        },
        paint: {
            'text-opacity': [
                'step',
                ['zoom'],
                0,
                14, 0.8,
            ],
            'text-color': '#000',
            'text-halo-color': '#fff',
            'text-halo-width': 1,
        },
    };
    const jobAreaTitleLayer = {
        id: 'job_area_title',
        type: 'symbol',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('area')],
        layout: {
            'text-field': '{title}',
            'text-font': regularFont,
            'text-size': 10,
            'text-anchor': 'top',
            'text-offset': [0, 1.5],
        },
        paint: {
            'text-color': '#000',
            'text-halo-color': '#fff',
            'text-halo-width': 2,
        },
    };
    const jobAreaCircleLayer = {
        id: 'job_area_circle',
        type: 'circle',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('area')],
        paint: {
            'circle-radius': 15,
            'circle-color': [
                'case',
                ['boolean', ['feature-state', 'selected'], false],
                colors.selected,
                [
                    'step',
                    ['get', 'typeid'],
                    colors.fallback,
                    10, colors.country, // country
                    20, colors.region, // region
                    30, colors.municipality, // municipality
                    40, colors.fallback, // city
                    50, colors.zipcode, // zipcode
                ]
            ],
        },
    };
    const jobAreaCountLayer = {
        id: 'job_area_count',
        type: 'symbol',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('area')],
        layout: {
            'text-allow-overlap': true,
            'text-field': '{job_count}',
            'text-font': boldFont,
            'text-size': 12,
        },
        paint: {
            'text-color': '#fff',
        },
    };
    const jobAddressLayer = {
        id: 'job_address',
        type: 'symbol',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('address')],
        layout: {
            'text-field': [
                'step',
                ['get', 'job_count'],
                '',
                2, ['get', 'job_count'],
                10, '+9',
            ],
            'text-allow-overlap': true,
            'text-font': boldFont,
            'text-size': 10,
            'text-offset': [0, -2.1],
            'icon-image': 'address',
            'icon-size': scaleFactor,
            'icon-anchor': 'bottom',
            'icon-allow-overlap': true,
        },
        paint: {
            'icon-opacity': [
                'case',
                ['boolean', ['feature-state', 'selected'], false],
                0,
                1
            ],
            'text-color': colors.address_count,
        }
    };

    const jobAddressLayerSelected = {
        id: 'job_address_selected',
        type: 'symbol',
        source: 'jobsearch',
        filter: ['all', ['!', isCluster], isOfType('address')],
        layout: {
            'icon-image': 'address-selected',
            'icon-size': scaleFactor,
            'icon-anchor': 'bottom',
            'icon-allow-overlap': true,
        },
        paint: {
            'icon-opacity': [
                'case',
                ['boolean', ['feature-state', 'selected'], false],
                1,
                0
            ],
        }
    };

    const clusterCircleLayer = {
        id: 'clusters_circle',
        type: 'circle',
        source: 'jobsearch',
        filter: isCluster,
        paint: {
            'circle-color': colors.cluster,
            'circle-radius': [
                'step',
                ['get', 'point_count'],
                15,
                100,
                25,
            ],
        },
    };

    const clusterCountLayer = {
        id: 'clusters_count',
        type: 'symbol',
        source: 'jobsearch',
        filter: isCluster,
        layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': boldFont,
            'text-size': 12,
            'text-allow-overlap': false,
        },
        paint: {
            'text-color': '#fff',
        },
    };

    return [
        jobAddressTitleLayer,
        jobAreaTitleLayer,
        jobAreaCircleLayer,
        jobAreaCountLayer,
        jobAddressLayerSelected,
        jobAddressLayer, // must come after jobAddressLayerSelected to allow text to render
        clusterCircleLayer,
        clusterCountLayer,
    ];
}
